import React from 'react';

function Bodies(props) {
	let bodies = {
		Body0: Body0,
		Body1: Body1,
		Body2: Body2,
		Body3: Body3,
		Body4: Body4,
		Body5: Body5
	};

	let propBody = 'Body' + props.body;

	let Body = bodies[propBody];

	return <Body />;
}

function Body0() {
	return (
		<path className="fill" d="M378.5,322.5c0.1-0.9,0.2-1.8,0.3-2.7c0.7-11,2.7-54.1-36.1-88.5c-22.4-19.9-43.8-27-73.5-28
		c-2.2-3.3-4.5-7.4-5.5-11.2c-2.7-10.3-14.1-16.6-24.3-13.8c-4.4,1.2-7.9,3.9-10.4,7.3c-12.6-12.5-31.8-16.6-46.9-5.2
		c-2.1-1.7-4.5-3-7-3.7c-11-3-19.6,4.2-24.3,13.8c-11,22.2-11,56.8-11,59.3c0,0,1.3,99.5,1.3,111.5c0,25.4,39.7,25.5,39.6,0
		c0-12,0-24,0-36.1l0-10.3c0-0.1,0-0.1,0-0.2c0.3-0.3,0.7-0.5,1-0.8c2.3-1.1,12.7,5.7,12.7,8c0,12.8,0,25.5,0,38.3
		c0,25.4,39.5,25.5,39.5,0c0-5.8,0-11.5,0-17.3c2,0.5,4.3,0.7,6.9,0.5c5.2-0.5,9.3-0.2,13.1,0.6c-10.4,9.8-5.8,33.5,13.5,35.5
		c28.4,2.9,67.3-1.2,90.8-20.2c5.1,10.5,1.2,23.6-14.3,27.2c-24.7,5.8-53.7,4.2-78.9,3.7c-25.4-0.5-25.4,39,0,39.5
		c26.2,0.5,52.4-0.4,78.3-3.6c19.9-2.5,37.5-9.6,48.4-27.5C408.3,371.4,399.7,341.1,378.5,322.5z"/>
);
}

function Body1() {
	return (
		<path className="fill" d="M378,323.5c0.1-0.9,0.2-1.8,0.3-2.7c0.7-11,2.7-54.1-36.1-88.5c-22.4-19.9-43.8-27-73.5-28
		c-2.2-3.3-4.5-7.4-5.5-11.2c-2.7-10.3-14.1-16.6-24.3-13.8c-4.4,1.2-7.9,3.9-10.4,7.3c-12.6-12.5-31.8-16.6-46.9-5.2
		c-2.1-1.7-4.5-3-7-3.7c-11-3-19.6,4.2-24.3,13.8c-4.7,9.5-7.4,21.3-8.9,31.9c-12.2,17.6-12.1,42-1.6,60.4
		c0.4,30.1,0.9,71.1,0.9,78.5c0,25.4,39.6,25.5,39.5,0c0-12-0.1-24-0.1-36.1v-0.5c3-1.3,6.8-1.4,10.2,0.4c1.2,0.6,2.4,1,3.7,1.2
		c0,11.2,0,22.5,0,33.7c0,25.4,39.5,25.5,39.5,0c0-5.8,0-11.5,0-17.3c2,0.5,4.3,0.7,6.9,0.5c5.2-0.5,9.3-0.2,13.1,0.6
		c-10.4,9.8-5.8,33.5,13.5,35.5c28.4,2.9,67.3-1.2,90.8-20.2c5.1,10.5,1.2,23.6-14.3,27.2c-24.7,5.8-53.7,4.2-78.9,3.7
		c-25.4-0.5-25.4,39,0,39.5c26.2,0.5,52.4-0.4,78.3-3.6c19.9-2.5,37.5-9.6,48.4-27.5C407.8,372.4,399.2,342.1,378,323.5z"/>
);
}

function Body2() {
	return (
		<path className="fill" d="M379,322.5c0.1-0.9,0.2-1.8,0.3-2.7c0.7-11,2.7-54.1-36.1-88.5c-22.4-19.9-43.8-27-73.5-28
			c-2.2-3.3-4.5-7.4-5.5-11.2c-2.7-10.3-14.1-16.6-24.3-13.8c-4.4,1.2-7.9,3.9-10.4,7.3c-12.6-12.5-31.8-16.6-46.9-5.2
			c-2.1-1.7-4.5-3-7-3.7c-11-3-19.6,4.2-24.3,13.8c-3.6,7.4-6.1,16.1-7.7,24.6c-18.4,10.4-27.6,32.6-25.2,53.2
			c2,17.5,10.6,32.3,22.7,44.2c0.3,22.5,0.5,43.7,0.5,48.8c0,25.4,39.5,25.5,39.4,0c0-9-0.1-18-0.2-27c1.6-2.6,4.2-2.8,7.7-2.2
			c2.2,0.4,4.3,1.2,6.4,1.9c0,8.7,0,17.4,0,26.1c0,25.4,39.5,25.5,39.6,0c0-5.8,0-11.5,0-17.3c2,0.5,4.3,0.7,6.9,0.5
			c5.2-0.5,9.4-0.2,13.1,0.6c-10.4,9.8-5.8,33.5,13.5,35.5c28.4,2.9,67.3-1.2,90.8-20.2c5.1,10.5,1.2,23.6-14.3,27.2
			c-24.7,5.8-53.7,4.2-78.9,3.7c-25.4-0.5-25.4,39,0,39.5c26.2,0.5,52.4-0.4,78.3-3.6c19.9-2.5,37.5-9.6,48.4-27.5
			C408.8,371.4,400.2,341.1,379,322.5z"/>
	);
}

function Body3() {
	return (
		<path className="fill" d="M416,353.9c-6.2-17.7-19.6-36.3-37.6-43.9c-0.5-17.9-5.7-50.6-36.4-77.8c-22.4-19.9-43.8-27-73.5-28
			c-2.2-3.3-4.5-7.4-5.5-11.2c-2.7-10.3-14.1-16.6-24.3-13.8c-4.4,1.2-7.9,3.9-10.4,7.3c-12.6-12.5-31.8-16.6-46.9-5.2
			c-2.1-1.7-4.5-3-7-3.7c-11-3-19.6,4.2-24.3,13.8c-1.9,3.9-3.5,8.1-4.8,12.4c-2.5-4-20.8,21.1-20.8,21.1c-9.5,11-15.4,25.4-16.3,39.2
			c-0.2,0.9-0.3,1.9-0.3,2.9c1,35.2,19.9,67.7,34.8,97.7c6.8,18.4,37.1,21.6,37.1-2.6c0-4,0-8.1-0.1-12.1c4.6,1,9.2,1.9,13.9,2.6
			c0,2.8,0,5.6,0,8.4c0,25.4,28.4,27.8,38.1,7.8c0.8-1.6,12.1-12.9,16.2-13c-1.3,10.6,4.9,23.1,18.7,24.5c28.4,2.9,67.3-1.2,90.8-20.2
			c5.1,10.5,1.2,23.6-14.3,27.2c-24.7,5.8-53.7,4.2-78.9,3.7c-13.7-0.3-20,11-19,21.6c-0.1,0.5-0.1,1-0.1,1.6
			c-0.1,10.2,6.1,19.5,15,24.3c8.9,4.8,19.5,5.2,29.4,5.3c21.3,0.3,42.9-2.5,63.5-8c18.8-5.1,38.6-12.8,51.5-28.1
			C417.7,392.6,422.7,373,416,353.9z"/>
	);
}

function Body4() {
	return (
		<path className="fill" d="M417,352.9c-6.2-17.7-19.6-36.3-37.6-43.9c-0.5-17.9-5.7-50.6-36.4-77.8c-22.4-19.9-43.8-27-73.5-28
			c-2.2-3.3-4.5-7.4-5.5-11.2c-2.7-10.3-14.1-16.6-24.3-13.8c-4.4,1.2-7.9,3.9-10.4,7.3c-12.6-12.5-31.8-16.6-46.9-5.2
			c-2.1-1.7-4.5-3-7-3.7c-8.3-2.3-9.6,14.1-11.8,26.3c-38.1,10.9-56.6,35.9-56.6,74.1c0,28.7,9.6,54.3,30.2,71.5
			c1.9,5.2,4.1,10.3,6.6,15.3c6,16.3,30.5,20.7,36,4.6c5.4,1.2,11.1,2,17.2,2.6c6.4,13.6,25,13.6,34,0.1c7.1-0.5,14.1-1.2,20.8-2.2
			c3,5.4,8.3,9.6,16,10.4c28.4,2.9,67.3-1.2,90.8-20.2c5.1,10.5,1.2,23.6-14.3,27.2c-24.7,5.8-53.7,4.2-78.9,3.7
			c-13.7-0.3-20,11-19,21.6c-0.1,0.5-0.1,1-0.1,1.6c-0.1,10.2,6.1,19.5,15,24.3c8.9,4.8,19.5,5.2,29.4,5.3c21.3,0.3,42.9-2.5,63.5-8
			c18.8-5.1,38.6-12.8,51.5-28.1C418.7,391.6,423.7,372,417,352.9z"/>
	);
}

function Body5() {
	return (
		<path className="fill" d="M379,323c0.1-0.9,0.2-1.8,0.3-2.7c0.7-11,2.7-54.1-36.1-88.5c-22.4-19.9-43.8-27-73.5-28
			c-2.2-3.3-4.5-7.4-5.5-11.2c-2.2-8.5-10.4-14.3-19-14.5c-1.9-0.1-3.9,0.1-5.8,0.6c-4.2,1.2-7.7,3.7-10.2,7
			c-7.5-7.3-17.3-11.7-27.1-11.6c-6.8-0.1-13.6,2-19.7,6.5c-2-1.6-4.3-2.9-6.7-3.5c-11-3-19.6,4.2-24.3,13.8c-2.9,6-5.1,12.8-6.7,19.7
			c-25.5,13.1-38,35.5-38,66.9c0,28.7,9.6,54.3,30.2,71.5c1.4,3.8,3,7.6,4.7,11.4c0,0.5,0,0.9,0,1.3c0,22.7,31.5,25.2,38.2,7.2
			c5.3,1.1,10.9,2,16.8,2.5c5.6,11.9,20.5,13.4,30.2,4.5c1.7-1.2,3.2-2.7,4.4-4.4c6.9-0.5,13.6-1.2,20.2-2.1c3,5.4,8.3,9.6,16,10.4
			c5.4,0.5,11.2,0.8,17.1,0.8c25.6,0,55-5.6,74.2-21c5.1,10.5,1.2,23.6-14.3,27.2c-24.7,5.8-53.7,4.2-78.9,3.7
			c-25.4-0.5-25.4,39,0,39.5c26.2,0.5,52.4-0.4,78.3-3.6c19.9-2.5,37.5-9.6,48.4-27.5C408.8,371.9,400.2,341.6,379,323z"/>

	);
}

export default Bodies;



// WEBPACK FOOTER //
// ./src/components/Global/Pet/Cat/Bodies.js